module.exports = __webpack_public_path__ + "img/about-direct-school-title.410df945.svg";